export const DIMMED_SCATTER_OPACITY = 0.15;
